import { render, staticRenderFns } from "./LearnMore.vue?vue&type=template&id=28ad6402&scoped=true&"
var script = {}
import style0 from "./LearnMore.vue?vue&type=style&index=0&id=28ad6402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad6402",
  null
  
)

export default component.exports